import { otp } from '../../util/validations'
import { OtpTextInput } from './OtpTextInput'

export const otpForm = (): any => [
  {
    formItems: [
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        validationSchema: otp,
        inputType: 'box',
        maxLength: 6,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
